module.exports = __webpack_public_path__ + "img/u989.bbf57b81.svg";